module.exports = __webpack_public_path__ + "img/firestone3.8e3bed63.png";